import React from 'react';
import styled from 'styled-components';
import ValidacionExitosaOutside from '../components/ValidacionExitosaOutside';

const Wrapper = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  padding-bottom: 100px;
`;

const ValidacionBiometriaOutside = () => {
  return (
    <Wrapper>
      <ValidacionExitosaOutside />
    </Wrapper>
  );
};

export default ValidacionBiometriaOutside;